import adminDashboardApi from '../../api/admin/adminDashboard'

export const state = () => ({
  dashboard: {}
})

export const getter = {}

export const mutations = {
  DASHBOARD (state, slug) {
    state.dashboard = { ...slug }
  }
}

export const actions = {
  async getDashboard ({commit}, params) {
    try {
      const res = await adminDashboardApi.getDashboard(params)
      if (res.status === 200) {
        commit('DASHBOARD', res.data.data)
      }
    } catch (error) {

    }
  }
}

export default {
  namespaced: true,
  state,
  getter,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/admin/adminDashboard.js